import { authStore } from '@/store/auth-store'
import moment from 'moment'
import {
  momentDateFormat,
  slashedDateFormat,
  momentDateTimeFormat,
  slashedDateTimeFormat,
  systemNamePosting,
  systemNameOrikomi,
} from '../utils/consts'
import {
  baseDomain,
  orikomiDomain,
  paymentDomain,
  clientManagementDomain,
  geenieDomain,
  storageDomain,
} from '../utils/baseConsts'
import { accountStore } from '../store/account-store'
import { aiStore } from '../store/ai-store'

export default (function () {
  const domain = baseDomain // "posting-api.adx-co.jp"
  const domainClient = baseDomain // "posting-api.adx-co.jp"
  const backendApiDomain = domain + '/api'
  const backendClientApiDomain = domainClient + '/api'
  const orikomiApiDomain = orikomiDomain + '/api'
  const geenieApiDomain = geenieDomain + '/api'
  const paymentApiDomain = paymentDomain + '/api'
  const storageApiDomain = storageDomain + '/api'
  const clientManagementApiDomain = clientManagementDomain + '/api'

  const backendWebSocketDomain = domain + ':9001'

  const fetchCoreClient = async (
    subPath,
    reqBody,
    outputObj = false,
    outputJson = true,
    cancelToken = false
  ) => {
    return fetchCore(
      backendClientApiDomain,
      subPath,
      reqBody,
      outputObj,
      outputJson,
      cancelToken
    )
  }

  const fetchCorePosting = async (
    subPath,
    reqBody,
    outputObj = false,
    outputJson = true,
    cancelToken = false
  ) => {
    return fetchCore(
      backendApiDomain,
      subPath,
      reqBody,
      outputObj,
      outputJson,
      cancelToken
    )
  }

  const fetchCoreGeenie = async (
    subPath,
    reqBody,
    outputObj = false,
    outputJson = true,
    cancelToken = false
  ) => {
    return fetchCore(
      geenieApiDomain,
      subPath,
      reqBody,
      outputObj,
      outputJson,
      cancelToken
    )
  }

  const fetchCoreOrikomi = async (
    subPath,
    reqBody,
    outputObj = false,
    outputJson = true,
    cancelToken = false
  ) => {
    return fetchCore(
      orikomiApiDomain,
      subPath,
      reqBody,
      outputObj,
      outputJson,
      cancelToken
    )
  }

  const fetchCoreStorage = async (
    subPath,
    reqBody,
    outputObj = false,
    outputJson = true,
    cancelToken = false
  ) => {
    return fetchCore(
      storageDomain,
      subPath,
      reqBody,
      outputObj,
      outputJson,
      cancelToken
    )
  }

  const fetchCorePayment = async (
    subPath,
    reqBody,
    outputObj = false,
    outputJson = true,
    cancelToken = false
  ) => {
    return fetchCore(
      paymentApiDomain,
      subPath,
      reqBody,
      outputObj,
      outputJson,
      cancelToken
    )
  }

  const fetchCoreClientManagement = async (
    subPath,
    reqBody,
    outputObj = false,
    outputJson = true,
    cancelToken = false
  ) => {
    return fetchCore(
      clientManagementApiDomain,
      subPath,
      reqBody,
      outputObj,
      outputJson,
      cancelToken
    )
  }

  const fetchCore = async (
    baseDomainClient,
    subPath,
    reqBody,
    outputObj = false,
    outputJson = true,
    cancelToken = false
  ) => {
    if (
      !authStore.getters.isAuthorized &&
      subPath !== '/v1/login' &&
      subPath !== '/v1/request_2fa' &&
      subPath !== '/v1/2fa_verification' &&
      subPath !== '/v1/client/forget_password' &&
      subPath !== '/v1/client/init_register' &&
      subPath !== '/v1/guest_login' && 
      subPath !== '/v1/client/init_register_customer_id'
    ) {
      return 'auth and subpath'
    }
    const opts = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: authStore.state.token,
      },
      method: 'POST',
    }

    if (reqBody) {
      opts.body = JSON.stringify(reqBody)
    }

    const resp = await fetch(baseDomainClient + subPath, opts)

    //Expired Token  //Wrong Token の場合はログインページに遷移
    if (subPath !== '/v1/my_profile' && subPath !== '/v1/check_registration' && subPath !== '/v1/ask_customer_service') {
      if (!cancelToken) {
        if (resp.headers.get('Authorization')) {
          authStore.commit('updateToken', resp.headers.get('Authorization'))
        }
      }
    }

    if (outputJson) {
      const jsonObj = await resp.json()
      if (
        jsonObj.error_message == 'Expired Token' ||
        jsonObj.error_message == 'Wrong Token' ||
        jsonObj.description == 'expired token'
      ) {
        authStore.commit('updateToken', '')
        location.href = '/login'
      }
      return jsonObj
    }

    const bodyText = await resp.text()

    if (bodyText.length === 0) {
      return null
    }

    const bodyObj = JSON.parse(bodyText)
    // if (outputObj) {
    // }

    return bodyObj
  }

  const tryLogin = async (
    userId,
    password,
    baseUrl,
    callbackUrl,
    returnUrl,
    cartSystemId,
    storeUrl
  ) => {
    const obj = {
      user_id: userId,
      password: password,
      base_url: baseUrl,
      callback_url: callbackUrl,
      return_url: returnUrl,
      cart_system_id: cartSystemId,
      store_url: storeUrl,
    }
    return fetchCoreClientManagement('/v1/login', obj)
  }
  
  const tryLoginGoogle = async (
    cartSystemId,
    idToken 
  ) => {
    const url =  clientManagementDomain + '/api/v1/login/google'; // Your backend endpoint
    
    const payload = {
      cart_system_id: cartSystemId,
    };

    try {
      const response = await fetch(url, {
        method: 'POST', // Use POST for login/registration
        
        headers: {
          'Authorization': `Bearer ${idToken}`, 
          'Content-Type': 'application/json',
        },
        
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        // Handle HTTP errors (e.g., 401 Unauthorized, 400 Bad Request)
        const errorData = await response.json();
        throw new Error(`Login failed: ${response.status} - ${errorData.message || 'Server error'}`);
      }

      if (response.headers.get('Authorization')) {
        authStore.commit('updateToken', response.headers.get('Authorization'))
        console.log(response.headers.get('Authorization'))
      }

      // Success! Get your new Ato session data/JWT/cookie confirmation
      const successData = await response.json();
      console.log('Login Success! Received data:', successData);
      return successData;

    } catch (error) {
      console.error('Error during Google login fetch:', error);
      throw error;
    }
  };

  const fetchReq2fa = async (
    userId,
    password,
    baseUrl,
    callbackUrl,
    returnUrl,
    cartSystemId,
    storeUrl,
    two_fa_type,
    is_first_auth
  ) => {
    // const isInitEmailFinal = two_fa_type.trim() === 'email' && is_first_auth == true
    const obj = {
      user_id: userId,
      password: '',
      base_url: baseUrl,
      callback_url: callbackUrl,
      return_url: returnUrl,
      cart_system_id: cartSystemId,
      store_url: storeUrl,
      two_fa_type: two_fa_type,
        // initial_email_authentication: isInitEmailFinal
        // initial_email_authentication: true
    }
    return fetchCoreClientManagement('/v1/request_2fa', obj)
  }
  
  const fetchVerify2fa = async (
    userId,
    password,
    baseUrl,
    callbackUrl,
    returnUrl,
    cartSystemId,
    storeUrl,
    two_fa_type,
    totp
  ) => {
    const obj = {
      user_id: userId,
      password: '',
      base_url: baseUrl,
      callback_url: callbackUrl,
      return_url: returnUrl,
      cart_system_id: cartSystemId,
      store_url: storeUrl,
      two_fa_type: two_fa_type,
      totp: totp
    }
    return fetchCoreClientManagement('/v1/2fa_verification', obj)
  }

  const forgotPassword = async (userIdMail) => {
    const obj = {
      user_id: userIdMail,
      cart_system_id: 1,
    }
    return fetchCoreClientManagement('/v1/client/forget_password', obj)
  }

  const registerInitUser = async (userObj) => {
    return fetchCoreClientManagement('/v1/client/init_register', userObj)
  }

  const registerInitUserCode = async (userObj) => {
    return fetchCoreClientManagement('/v1/client/init_register_customer_id', userObj)
  }

  const refCartGroupBy = async () => {
    return fetchCorePosting('/v2/plan/2d_per_group')
  }

  const refCartGroupByOrikomi = async () => {
    //  return fetchCoreOrikomi("/v1/cart/ref_group_by")
    return fetchCoreOrikomi('/v1/plan/2d_per_group')
  }
  const refCartGroupByGeenie = async () => {
    //  return fetchCoreOrikomi("/v1/cart/ref_group_by")
    return fetchCoreGeenie('/v1/plan/2d_per_group')
  }

  const refCartGroupClientManagement = async () => {
    return fetchCoreClientManagement('/v1/plan/2d_per_group')
  }

  const allMenuList = async () => {
    return fetchCorePosting('/v1/all_menu_list')
  }
  /*
    const refOrderLimit = async(limit,postingStatus = -1) => {
        const obj = {
            limit : limit,
            posting_status : postingStatus
        }
        return fetchCore("/v2/order/ref_limit",obj)
    }*/

  const refOrderLimitGroupBy = async (
    limit,
    status,
    printing_status,
    orderKey,
    refText,
    fromTime,
    toTime,
    userId
  ) => {
    const obj = {
      limit: limit,
      status: status,
      printing_status,
      order_key: orderKey,
      ref_text: refText,
      from_time: fromTime,
      to_time: toTime,
      user_id: userId,
    }
    return fetchCorePosting('/v1/order/search_2d_per_group', obj)
    // return fetchCorePosting("/v2/order/search_2d_per_group", obj);
  }

  const refOrderLimitGroupByGeenie = async (
    limit,
    status,
    orderKey,
    refText,
    fromTime,
    toTime,
    userId
  ) => {
    const obj = {
      limit: limit,
      status: status,
      order_key: orderKey,
      ref_text: refText,
      from_time: fromTime,
      to_time: toTime,
      user_id: userId,
    }
    return fetchCoreGeenie('/v1/order/search_2d_per_group', obj)
  }
  const refOrderLimitGroupByTicket = async (
    limit,
    orderKey,
    fromTime,
    toTime,
    userId
  ) => {
    const obj = {
      limit: limit,
      order_key: orderKey,
      from_time: fromTime,
      to_time: toTime,
      user_id: userId,
    }
    return fetchCoreClientManagement('/v1/order/search_2d_per_group', obj)
  }
  const refOrderLimitGroupByOrikomi = async (
    limit,
    status,
    orderKey,
    refText,
    fromTime,
    toTime,
    userId
  ) => {
    const obj = {
      limit: limit,
      status: status,
      order_key: orderKey,
      ref_text: refText,
      from_time: fromTime,
      to_time: toTime,
      user_id: userId,
    }
    return fetchCoreOrikomi('/v1/order/search_2d_per_group', obj)
  }
  const refOrderFileName = async (orderKey) => {
    const obj = {
      order_key: orderKey,
      system_name: systemNamePosting,
    }
    return fetchCore(
      storageApiDomain,
      '/v1/order/media_name',
      obj,
      false,
      true,
      false
    )
  }

  const refOrderFileNameOrikomi = async (orderKey) => {
    const obj = {
      order_key: orderKey,
      system_name: systemNameOrikomi,
    }
    return fetchCore(
      storageApiDomain,
      '/v1/order/media_name',
      obj,
      false,
      true,
      false
    )
  }

  const uploadOrderFileOrikomi = async (orderKey, filaName, fileData) => {
    const obj = {
      order_key: orderKey,
      file_name: fileName,
      file_data: fileData,
    }
    return fetchCoreOrikomi('/api/v1/order/upload_media', obj)
  }
  const orderReceive = async (
    planKey,
    dataType,
    paymentMethod,
    convenienceCode,
    usePoints,
    couponCode,
    deliveryAddress
  ) => {
    /*
        *
        * 00001	ローソン
00002	ファミリーマート
00005	ミニストップ
00006	デイリーヤマザキ
00007	セブンイレブン
00008	セイコーマート
        *
        * */
    // paymentMethod = 'cvs'

    // let cvsNumber = ''
    // cvsNumber = '00007'
    // if (paymentMethod == 'seven-eleven') {
    //   paymentMethod = 'cvs'
    //   cvsNumber = '00007'
    // } else if (paymentMethod == 'lawson') {
    //   paymentMethod = 'cvs'
    //   cvsNumber = '00001'
    // } else if (paymentMethod == 'secoma') {
    //   paymentMethod = 'cvs'
    //   cvsNumber = '00008'
    // }
    let obj = {}
    if (paymentMethod == 'cvs') {
      obj = {
        plan_key: planKey,
        payment_method: paymentMethod,
        convenience_code: convenienceCode,
        point_usage: usePoints,
        coupon_code: couponCode || ''
        // ...(dataType === 'posting_and_print'
        //   ? { direct_delivery_destination: deliveryAddress || [] }
        //   : { delivery_address: deliveryAddress || '' })
        };
      }
     else {
      obj = {
        plan_key: planKey,
        payment_method: paymentMethod,
        point_usage: usePoints,
        coupon_code: couponCode || ''
        // ...(dataType === 'posting_and_print'
        //   ? { direct_delivery_destination: deliveryAddress || [] }
        //   : { delivery_address: deliveryAddress || '' })
        };
    }
    // console.log(dataType, obj, 'calling order/receive')
    // return

    if (dataType == 'posting') {
      //   const obj = {
      //     plan_key: planKey,
      //     payment_method: paymentMethod,
      //     // convenience_code: cvsNumber,
      //     convenience_code: convenienceCode,
      //   }
      return fetchCorePosting('/v1/order/receive', obj)
    } else if (dataType == 'posting_and_print') {
      return fetchCorePosting('/v1/order/receive', obj)
    } else if (dataType == 'geenie') {
      return fetchCoreGeenie('/v1/order/receive', obj)
    } else if (dataType == 'ticket') {
      return fetchCoreClientManagement('/v1/order/receive', obj)
    } else {
      //   const obj = {
      //     plan_key: planKey,
      //     payment_method: paymentMethod,
      //     // convenience_code: cvsNumber,
      //     convenience_code: convenienceCode,
      //   }
      return fetchCoreOrikomi('/v1/order/receive', obj)
    }
  }

  const couponVerification = async (data) => {
    const obj = data
    // return fetchCorePosting('/v1/coupon_verification', obj)

    return await fetchCore(
      clientManagementApiDomain,
      '/v1/coupon_verification',
      obj
    )
  }
  
  const refOnProcessOrders = async (onProcessType) => {
    const obj = {
      on_process_type: onProcessType,
    }
    return fetchCorePosting('/v2/order/ref_on_process_orders', obj)
  }

  const refOnProcessOrders2dArray = async (onProcessType) => {
    const obj = {
      on_process_type: onProcessType,
    }
    return fetchCorePosting('/v2/order/on_process_2d_per_group', obj)
  }

  const setDirectDeliveryDestination = async (data) => {
  
    return fetchCorePosting('/v1/plan/set_direct_delivery_destination', data)
  }

  const setDirectDeliveryDestinationOrikomi = async (data) => {
  
    return fetchCoreOrikomi('/v1/plan/set_direct_delivery_destination', data)
  }

  const refOnProcessOrders2dArrayOrikomi = async (onProcessType) => {
    const obj = {
      on_process_type: onProcessType,
    }
    return fetchCoreOrikomi('/v1/order/on_process_2d_per_group', obj)
  }

  const refOrder = async (orderKey) => {
    const obj = {
      order_key: orderKey,
    }
    return fetchCorePosting('/v1/order/ref', obj)
  }
  const refOrderGeenie = async (orderKey) => {
    const obj = {
      order_key: orderKey,
    }
    return fetchCoreGeenie('/v1/order/ref', obj)
  }
  const refOrderTicket = async (orderKey) => {
    const obj = {
      order_key: orderKey,
    }
    return fetchCoreClientManagement('/v1/order/ref', obj)
  }

  const demographicsGeenie = async (obj) => {
    return fetchCoreGeenie('/v1/target/demographics', obj)
  }
  const osGeenie = async (obj) => {
    return fetchCoreGeenie('/v1/target/os', obj)
  }
  const daysGeenie = async (obj) => {
    return fetchCoreGeenie('/v1/target/days', obj)
  }
  const hoursGeenie = async (obj) => {
    return fetchCoreGeenie('/v1/target/hours', obj)
  }
  const textAreaGeenie = async (orderKey) => {
    const obj = {
      order_key: orderKey,
    }
    return fetchCoreGeenie('/v1/order/area_text', obj)
  }

  const guestLogin = async () => {
    if (authStore.state.token) {
      return 'already login'
    }
    const obj = {
      callback_url: '',
      base_url: '',
      cart_system_id: 1,
    }
    const opts = {
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify(obj),
    }

    const respBuffer = await fetch(
      clientManagementApiDomain + '/v1/guest_login',
      opts
    )

    const bodyText = await respBuffer.text()
    const tokenGuest = respBuffer.headers.get('Authorization')

    if (bodyText.length === 0) {
      return null
    }

    const resp = JSON.parse(bodyText)

    if (!resp.result === 'success') {
      return 'fail guest login'
    }

    const myAccountObj = {
      user_name: resp.value.name,
    }

    if (!authStore.state.token) {
      authStore.commit('updateToken', tokenGuest)
      accountStore.commit('updateMyAccount', myAccountObj)
      authStore.commit('updateName', resp.value.name)
      authStore.commit('updateDepartment', resp.value.department)
      authStore.commit('updateAuthLevel', resp.value.auth)
      authStore.commit('updateOrgType', resp.value.org_type)
      authStore.commit('updateIsGuest', true)
    }
    return resp
  }

  const refOrderOrikomi = async (orderKey) => {
    const obj = {
      order_key: orderKey,
    }
    return fetchCoreOrikomi('/v1/order/ref', obj)
  }

  const accountList = async () => {
    /*  const obj = {
            id : Number(id)
        }*/

    const obj = {
      cart_system_id: 1,
      page: 1,
      limit: 1000,
    }
    return fetchCoreClientManagement('/v1/client/list', obj)
  }
  const accountUpdate = async (account) => {
    return fetchCoreClientManagement('/v1/client/update', account)
  }

  const accountInsert = async (account) => {
    return fetchCoreClientManagement('/v1/client/add', account)
  }

  const accountDelete = async (account) => {
    return fetchCoreClientManagement('/v1/client/delete', account)
  }

  const myAccountInfo = async () => {
    return fetchCoreClientManagement('/v1/my_profile')
  }
  const pointHistory = async () => {
    return fetchCoreClientManagement('/v1/points/history')
  }

  const myAccountInfoUpdate = async (accountInfo) => {
    return fetchCoreClientManagement('/v1/my_profile_update', accountInfo)
  }
  const comppanyNameUpdate = async (accountInfo) => {
    return fetchCoreClientManagement('/v1/company_update', accountInfo)
  }
  const myAccountCompanyUpdate = async (accountInfo) => {
    return fetchCoreClientManagement('/v1/company_update', accountInfo)
  }

  const myAccountFirstAddressUpdate = async (firstAddress) => {
    return fetchCoreClientManagement('/v1/client/address_update', firstAddress)
  }

  const myAccountPasswordUpdate = async (accountPassword) => {
    return fetchCoreClientManagement('/v1/password_update', accountPassword)
  }

  const updateTrackingInfo = async (
    orderKey,
    destinationId,
    shippingCompany,
    tracking,
    dataType
  ) => {
    if (dataType == 'posting' || dataType == 'posting_and_print') {
      const obj = {
        order_key: orderKey,
        destination_id: Number(destinationId),
        shipping_company: shippingCompany,
        tracking: tracking,
      }
      return fetchCorePosting('/v1/order/update_tracking', obj)
    } else if (dataType == 'orikomi') {
      const obj = {
        order_key: orderKey,
        destination_id: Number(destinationId),
        shipping_company: shippingCompany,
        tracking: tracking,
      }
      return fetchCoreOrikomi('/v1/order/update_tracking', obj)
    }
  }

  const updateTowerTracking = async (
    data
  ) => {
      return fetchCorePosting('/v1/order/update_tower_tracking', data)
  }

  const authorizePlans = async (groupId) => {
    const obj = {
      group_id: Number(groupId),
    }
    return fetchCorePosting('/v1/plan/authorize', obj)
  }
  const authorizePlansTicket = async (planKey) => {
    const obj = {
      plan_key: planKey,
    }
    return fetchCoreClientManagement('/v1/plan/authorize', obj)
  }

  const authorizePlansOrikomi = async (groupId) => {
    const obj = {
      group_id: Number(groupId),
    }
    return fetchCoreOrikomi('/v1/plan/authorize', obj)
  }
  const authorizePlansGeenie = async (groupId) => {
    const obj = {
      group_id: Number(groupId),
    }
    return fetchCoreGeenie('/v1/plan/authorize', obj)
  }

  //通常は、apiを叩くたびに、チェックがなされるが、mapは別プレジェクトであるため、mapに遷移する前にtokenの真正をチェックする
  const verifyToken = async () => {
    return fetchCorePosting('/v1/verify_token')
  }

  const planHistory = async () => {
    let fromDate = moment().utcOffset(9).add(-1, 'years')
    //万一の時間の狂いを考慮して1時間先までの日付けとする
    let toDate = moment().utcOffset(9).add(1, 'hours')
    const obj = {
      from_datetime: fromDate.format(slashedDateTimeFormat),
      to_datetime: toDate.format(slashedDateTimeFormat),
    }
    return fetchCorePosting('/v1/plan/history', obj)
  }

  const deleteCart = async (planKey, dataType) => {
    const obj = {
      plan_key: planKey,
    }

    if (dataType == 'posting' || dataType == 'posting_and_print') {
      return fetchCorePosting('/v1/plan/delete', obj)
    } else if (dataType == 'orikomi' || dataType == 'orikomi_print') {
      return fetchCoreOrikomi('/v1/plan/delete', obj)
    } else if (dataType == 'ticket') {
      return fetchCoreClientManagement('/v1/plan/delete', obj)
    } else {
      return fetchCoreGeenie('/v1/plan/delete', obj)
    }
  }

  /* Payment relation */

  const payment = async (val) => {
    const obj = { amount: val }
    return fetchCorePayment('/v1/payment', obj)
  }

  const showVa = async (obj) => {
    return fetchCorePayment('/v1/request_customer_va', obj)
  }

  const cancelPayment = async () => {
    const obj = {
      access_id: 'd2834c3b1996353cca1e444dae959ad3',
      access_pass: '46ac32d4d174dbaceea9c33d2bca08e8',
    }
    return fetchCorePayment('/v1/cancel_payment', obj)
  }

  const getRegisterLink = async () => {
    return fetchCorePayment('/v1/card_link_to_register')
  }
  const registeredCheck = async (payload) => {
    return fetchCorePayment('/v1/check_registration', payload)
  }

  const registerCard = async (payload) => {
    return fetchCorePayment('/v1/register_card', payload)
  }

  const registerUser = async (userObj) => {
    return await fetchCore(
      clientManagementApiDomain,
      '/v1/client/init_register',
      userObj
    )
  }

  const sendForgetPasswordMail = async (userIdMail) => {
    return await fetchCore(
      clientManagementApiDomain,
      '/v1/client/forget_password',
      {
        user_id: userIdMail,
        cart_system_id: 1,
      }
    )
  }

  const saveEstimationPlanPosting = async (obj) => {
    obj.saved_date = moment(new Date(), slashedDateFormat).format(
      slashedDateFormat
    )

    return fetchCoreClient('/v1/plan/save', obj)
  }

  const saveEstimationOrikomi = async (obj) => {
    return fetchCoreOrikomi('/v1/plan/save', obj)
  }

  const orderStatusListPosting = async (obj) => {
    return fetchCorePosting('/v1/order/status_list', obj)
  }

  const orderStatusListOrikomi = async (obj) => {
    return fetchCoreOrikomi('/v1/order/status_list', obj)
  }

  const orderStatusListGeenie = async (obj) => {
    return fetchCoreGeenie('/v1/order/status_list', obj)
  }

  const genieEstimateSend = async (objGenie, refText) => {
    objGenie.estim_id = 365

    const respEstimate = await fetchCoreGeenie('/v1/estimate', objGenie)
    if (respEstimate.result !== 'success') {
      return respEstimate
    }
    const objSave = respEstimate.value
    objSave.extra.ref_text = refText
    return fetchCoreGeenie('/v1/plan/save', objSave)
  }

  const sendCustomerAI = async (chatData) => {
    const sessionId = aiStore.state.sessionId
    const obj = {
      question: chatData,
      session_id: sessionId,
    }
  const japaneseCharRegex =
    /[\u0020\u3000-\u303F\u3002\u3040-\u309F\u30A0-\u30FF\uFF00-\uFFEF\u4E00-\u9FAF\u2605-\u2606\u2190-\u2195\u203B]/;
    const respObj = await fetchCoreClientManagement('/v1/ask_customer_service', obj)
    let content = respObj.value.answer
    if(respObj.result === "success") {
      console.log(content.includes("https"), "ashhkjsajhkaskhj")
      if(content.includes("https")){
        const startHttps = content.indexOf("https")
        let endHttps = 0
        for(let i = startHttps; i < content.length; i ++) {
          console.log(content[i], "Asjhkakhkhjas")
          if(japaneseCharRegex.test(content[i])) {
            endHttps = i 
            break
          }
        }
        if(endHttps === 0) {
          endHttps = content.length
        }
        const getHttps = content.slice(startHttps, endHttps)
        const urlHttpsHref = `<a href='${getHttps}' target='_blank'>${getHttps}</a>`
        let result = ''
        if(endHttps >= content.length) {
          result = content.slice(0, startHttps) + urlHttpsHref
        } else {
          result = content.slice(0, startHttps) + urlHttpsHref + content.slice(endHttps)
        }
        content = result
      }
      const objData = {
        role: 'AI',
        content: content,
      }
      aiStore.commit('sendChat', objData)
    }
  }

  return {
    tryLogin,
    tryLoginGoogle,
    fetchReq2fa,
    fetchVerify2fa,
    allMenuList,
    planHistory,
    //refCart,
    /*    refOrderLimit,*/
    orderReceive,
    setDirectDeliveryDestination,
    setDirectDeliveryDestinationOrikomi,
    refOnProcessOrders,
    refOrder,
    refOrderGeenie,
    refOrderTicket,
    backendWebSocketDomain,
    refOrderFileName,
    refOrderFileNameOrikomi,
    updateTrackingInfo,
    updateTowerTracking,
    deleteCart,
    verifyToken,
    refCartGroupBy,
    refCartGroupByOrikomi,
    refCartGroupByGeenie,
    refCartGroupClientManagement,
    refOnProcessOrders2dArray,
    refOnProcessOrders2dArrayOrikomi,
    refOrderLimitGroupBy,
    refOrderLimitGroupByOrikomi,
    refOrderLimitGroupByGeenie,
    refOrderLimitGroupByTicket,
    accountList,
    accountUpdate,
    accountInsert,
    accountDelete,
    myAccountInfo,
    pointHistory,
    myAccountInfoUpdate,
    comppanyNameUpdate,
    myAccountCompanyUpdate,
    myAccountFirstAddressUpdate,
    myAccountPasswordUpdate,
    authorizePlans,
    authorizePlansOrikomi,
    authorizePlansGeenie,
    authorizePlansTicket,
    uploadOrderFileOrikomi,
    refOrderOrikomi,
    getRegisterLink,
    registeredCheck,
    payment,
    showVa,
    cancelPayment,
    forgotPassword,
    registerInitUser,
    registerUser,
    sendForgetPasswordMail,
    registerCard,
    guestLogin,
    saveEstimationPlanPosting,
    genieEstimateSend,
    saveEstimationOrikomi,
    orderStatusListPosting,
    orderStatusListOrikomi,
    orderStatusListGeenie,
    textAreaGeenie,
    demographicsGeenie,
    osGeenie,
    hoursGeenie,
    daysGeenie,
    couponVerification,
    registerInitUserCode,
    sendCustomerAI,
  }
})()
